import { defineAgenda, param } from '@/shared/navigation/core';

/**
 * Agenda detailu stanice — jeden formulář pro založení i editaci. Bez `stationId` = založení,
 * s `stationId` = editace. Otevírá se jako modální vrstva nad seznamem stanic.
 */
export const stationDetailAgenda = defineAgenda({
  id: 'app.products.station-detail',
  path: 'app/products/station',
  open: {
    stationId: param.number().optional(),
  },
  title: 'Stanice',
  icon: 'map-pin',
  presentationHints: {
    shell: {
      layoutMode: 'overlay',
    },
  },
});
